package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import kotlinx.coroutines.flow.Flow

class ApproveInspectionUseCase(
    private val inspectionRepository: InspectionRepository,
) {
    operator fun invoke(id: String): Flow<FlowResult<Unit>> {
        return inspectionRepository.approveInspection(id)
    }
}
